import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import '../App.css';

export const Navbar = () => {
  
  return (
    <div><nav className="navbar navbar-expand-lg bg-body-tertiary" data-bs-theme="dark">
    <div className="container">
      <Link className="navbar-brand" to="/"><h3><b>newsy</b></h3></Link>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
          <li className="nav-item">
            <NavLink className="nav-link active" aria-current="page" to="/">Home</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/science">Science</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/technology">Technology</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/health">Health</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/entertainment">Entertainment</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/business">Business</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/politics">Politics</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/sports">Sports</NavLink>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  </div>
  )
}
